import React, { useState, createContext } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import { pairingById } from '../models/PairingByIdInterface';
import { getMonth, getYear } from '../helpers/dateHelpers';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';

const pairingByIdDefault:pairingById = {} as pairingById;

const PairingByIdContext = createContext({ loading: true, pairingDataById: pairingByIdDefault as pairingById, getPairingDataById: (selectedId, search) => { } });

export const PairingByIdProvider = (props) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [pairingDataById, setPairingDataById] = useState<pairingById>(pairingByIdDefault);
  const {setErrorCode} = useApiError();

  const getPairingDataById = async (selectedId, search) => {
    if (!user || !selectedId || !search) {
      return;
    }
    setLoading(true);
    try {
      const requestObject = {
        body: {
          year: getYear(search.selectedDate),
          month: getMonth(search.selectedDate),
          "pairingId": selectedId
        }
      };
      const pairingByIdRaw = await API.post('crewlife', '/pairings/retrieve', requestObject);
      setPairingDataById({ ...pairingByIdRaw });
      setLoading(false);
    } catch (e:any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <PairingByIdContext.Provider
      value={{
        getPairingDataById,
        pairingDataById,
        loading
      }} >
      {props.children}
    </PairingByIdContext.Provider>
  );
};

export const usePairingById = () => {
  return React.useContext(PairingByIdContext);
};

